module.exports = __webpack_public_path__ + "static/media/contactus.c1cc7169.jpg";